import React, { useState, useRef } from 'react';
import { timeBased, weeklySalesDistriution, timeSalesAnalysis } from '../../../../services/timeSalesAnalysis';
import { usePermissions } from '../../../../context/PermissionContext';

const useTimeSalesAnalysis = () => {
  const [timeBasedlState, setTimeBasedState] = useState([]);
  const [weeklySalesDistriutionState, setWeeklySalesDistriutionState] = useState([]);
  const [timeSalesAnalysisState, setTimeSalesAnalysisState] = useState([]);
  const [timeSalesAnalysisSequence, setTimeSalesAnalysisSequence] = useState([]);
  const [timeBasedFilter, setTimeBasedFilter] = useState('hourly');
  const [timeSalesAnalysisLoaded, setTimeSalesAnalysisLoaded] = useState(false); // NEW FLAG
  const [accessDenied, setAccessDenied] = useState(false);
  const [loadingState, setLoadingState] = useState({
    timeSalesAnalysisState: false,
    timeBasedlState: false,
    weeklySalesDistriutionState: false
  })

  const permission = usePermissions();

  const canShowTable =
    (permission?.data?.actionable_conditions?.view_format?.category_wise?.display &&
      permission?.data?.actionable_conditions?.view_format?.category_wise?.allowed) ||
    (permission?.data?.actionable_conditions?.view_format?.product_wise?.display &&
      permission?.data?.actionable_conditions?.view_format?.product_wise?.allowed);

  const combinedPermission = {
    display:
      permission?.data?.time_sales_analysis?.view_format?.category_wise?.display ||
      permission?.data?.time_sales_analysis?.view_format?.product_wise?.display,
    allowed:
      permission?.data?.time_sales_analysis?.view_format?.category_wise?.allowed ||
      permission?.data?.time_sales_analysis?.view_format?.product_wise?.allowed,
  };

  const getTimeBased = async ({ timeBasedFilter = [], formattedEnd, formattedStart, selectedIds = [] }) => {
    setLoadingState((prev) => ({
      ...prev,
      timeBasedlState: true
    }))
    try {
      const response = await timeBased({ timeBasedFilter, formattedEnd, formattedStart, selectedIds });
      if (response?.success && response.data) {
        setTimeBasedState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching time-based data:", error);
      if (error.status === 403) {
        setAccessDenied(true)
      }
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        timeBasedlState: false
      }))
    }
  };

  const getWeeklySalesDistriution = async ({ formattedEnd, formattedStart, selectedIds = [] }) => {
    setLoadingState((prev) => ({
      ...prev,
      weeklySalesDistriutionState: true
    }))
    try {
      const response = await weeklySalesDistriution({ formattedEnd, formattedStart, selectedIds });
      if (response?.success && response.data) {
        setWeeklySalesDistriutionState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching weekly distribution:", error);
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        weeklySalesDistriutionState: false
      }))
    }
  };

  const getTimeSalesAnalysis = async ({ formattedEnd, formattedStart, selectedIds = [] }) => {
    setLoadingState((prev) => ({
      ...prev,
      timeSalesAnalysisState: true
    }));
    setTimeSalesAnalysisLoaded(false);
    try {
      const response = await timeSalesAnalysis({ formattedEnd, formattedStart, selectedIds });
      if (response && response.success && response.data) {
        setTimeSalesAnalysisState(response.data);
        setTimeSalesAnalysisSequence(response?.sequence);
      } else {
        setTimeSalesAnalysisState([]);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching time sales analysis:", error);
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        timeSalesAnalysisState: false
      }));
      setTimeSalesAnalysisLoaded(true); // ✅ Mark loaded
    }
  };


  return {
    loadingState,
    timeBasedlState,
    weeklySalesDistriutionState,
    timeSalesAnalysisState,
    getTimeBased,
    getWeeklySalesDistriution,
    getTimeSalesAnalysis,
    timeBasedFilter,
    setTimeBasedFilter, timeSalesAnalysisSequence, timeSalesAnalysisLoaded, canShowTable, combinedPermission, accessDenied
  };
};

export default useTimeSalesAnalysis;
